/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, func, shape, string, array, arrayOf, bool,
} from 'prop-types';
import { useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Popover from '@material-ui/core/Popover';
import ReactMarkdown from 'react-markdown';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useUIDSeed } from 'react-uid';
import { AspectRatio } from '@material-ui/icons';
import WrapUpModal from '../../WrapUpPage/Partials/WrapUpModal';
import AddonInfoModal from './AddonInfoModal';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import PriceRange from '../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceRange';

const styles = (theme) => ({
    addonGroup: {
        width: '150px',
        cursor: 'pointer',
        margin: '0 25px 10px 0',
        borderRadius: '4px',
        padding: '10px',
    },
    imgContent: {
        display: 'block',
        width: '100%',
        height: '126px',
        textAlign: 'center',
    },
    img: {
        width: '90%',
        background: theme.palette.white,
    },
    wraupCopy: {
        // margin: 0,
        fontSize: '10px',
    },
    salePrice: {
        color: theme.palette.pdp.salePrice || '#a1001a',
        padding: '0 5px 0 5px',
    },
    defaultPrice: {
        padding: '0 5px 0 0',
    },
    ctaButton: {
        margin: '20px auto 0px',
        width: '90%',
        color: theme.palette.primary?.main,
        border: `1px solid ${theme.palette.primary?.main}`,
        textAlign: 'center',
        lineHeight: '20px',
        backgroundColor: theme?.palette.primary?.contrastText,
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: '500',
        fontSize: '14px',
        textTransform: 'uppercase',
        display: 'flex',
        alignItem: 'center',
        '& svg': {
            marginLeft: '13px',
        },
        '&:hover, &:focus, &:active': {
            color: theme.palette.primary?.contrastText,
            border: `1px solid ${theme.palette.primary?.main}`,
            backgroundColor: theme.palette.primary?.main,
            '& svg': {
                fill: '#ffffff',
            },
        },
        [theme?.breakpoints?.down('md')]: {
            fontSize: '16px',
        },
    },
    ctaAddedButton: {
        backgroundColor: theme.palette.primary?.main,
        color: theme.palette.cms?.white || '#ffffff',
        '& svg': {
            fill: '#ffffff',
        },
    },
    editButton: {
        margin: '20px auto',
        display: 'block',
        width: '90%',
        color: theme?.palette?.black,
        textAlign: 'center',
        lineHeight: '20px',
        backgroundColor: theme?.palette?.white,
        textDecoration: 'underline',
        cursor: 'pointer',
        fontWeight: '500',
        fontSize: '14px',
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme?.palette?.white,
            color: theme?.palette?.black,
            textDecoration: 'underline',
            boxShadow: 'none',
        },
        [theme?.breakpoints?.down('md')]: {
            fontSize: '18px',
        },
    },
    iconCheck: {
        color: theme.palette.secondary?.main,
        fontSize: '20px',
        verticalAlign: 'bottom',
        marginRight: '5px',
    },
    title: {
        color: theme?.palette?.black,
        textAlign: 'center',
        width: '100%',
        height: '32px',
        overflow: 'hidden',
        fontSize: '14px',
        lineHeight: '16px',
        margin: '5px 0',
        paddingRight: '2px',
    },
    popUp: {
        marginLeft: '125px',
        position: 'absolute',

    },
    seeTitles: {
        marginLeft: '32px',
        marginTop: '-12px',
        textDecoration: 'underline',
        color: '#65388b',
        fontSize: '12px',

    },
    popUpLink: {
        margin: '-7px 0 7px 0',
    },
    infoButton: {
        border: 'none',
        background: 'none',
        '&:focus': {
            outline: 'none',
        },
    },
    iconContent: {
        width: 400,
        padding: 10,
    },
    seeTitle: {
        display: 'block',
        padding: 0,
        height: 'auto',
        textAlign: 'center',
        marginBottom: 5,
    },
    movieTitle: {
        color: theme.palette?.black || '#000',
        textAlign: 'center',
        width: '100%',
        height: 25,
        overflow: 'hidden',
        fontSize: '14px',
        lineHeight: '16px',
        margin: '2px 0',
    },
    infoButtonSvg: {
        fill: theme.palette.cms?.primary || theme.palette.colorPrimary,
    },
    sliderGroup: {
        width: 'auto',
        margin: '20px 0px 0px 0px',
        padding: '0px',
        borderRadius: '0px',
        '@media screen and (max-width: 600px)': {
            marginTop: '24px',
        },
        '& $imgContent': {
            height: 'auto',
            position: 'relative',
        },
        '& $infoButton': {
            right: 'unset',
            bottom: '1px',
            left: '7px',
            position: 'absolute',
            '& svg': {
                width: '32px',
                height: '32px',
            },
        },
        '& $img': {
            width: '100%',
            display: 'flex',
            aspectRatio: '0.92/1',
        },
        '& $title': {
            fontSize: '16px',
            lineHeight: '21px',
            minHeight: '66px',
            margin: '12px 0px 0px',
            textDecorationLine: 'underline',
            textUnderlineOffset: '3px',
            textAlign: 'left',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '3',
            WebkitBoxOrient: 'vertical',
            '@media screen and (max-width: 600px)': {
                fontSize: '15px',
            },
        },
        '& $ctaButton': {
            fontSize: '16px',
            lineHeight: '24px',
            padding: '11px 5px',
            width: '100%',
            margin: '12px auto',
            borderRadius: '3px',
            textTransform: 'capitalize',
            boxShadow: 'none',
            fontWeight: 'normal',
            '@media screen and (max-width: 600px)': {
                marginBottom: '0px',
                fontSize: '15px',
            },
        },
    },
    priceContainer: {
        marginTop: '8px',
        '@media screen and (max-width: 600px)': {
            minHeight: '42px',
        },
        '& span': {
            fontSize: '16px',
            lineHeight: '21px',
            fontWeight: '750',
            '@media screen and (max-width: 600px)': {
                fontSize: '15px',
            },
        },
    },
});

const WrapUpUI = ({
    classes, wrapUpData, selectedGroupId, handleOpenModal, addOnData, wrapUpInfo, isSlider, selectItems, wrapupAddonRedesign,
}) => {
    if (!wrapUpData || !wrapUpData.skuPartNumber || !wrapUpData.sku) { return null; }
    const { sku, skuPartNumber } = wrapUpData;
    const seed = useUIDSeed();
    const [open, setOpen] = useState(false);
    const [openSeetitleModal, closeSeetitleModal] = useState(false);
    function handleSeetitleModal() {
        closeSeetitleModal(!openSeetitleModal);
    }
    const [info, setInfo] = useState('');
    const handleClick = (event) => {
        setInfo(event.currentTarget);
    };
    const handleClose = () => {
        setInfo('');
    };
    const handlePopup = () => {
        if (isSlider) {
            setOpen(true);
        }
    };
    const movieSku = addOnData?.[0]?.some((getsku) => getsku?.sku === skuPartNumber);
    const skuWrapUp = wrapUpInfo?.filter((itemInfo) => itemInfo?.sku === skuPartNumber && itemInfo?.info_on_hover);
    const hoverInfoData = skuWrapUp?.length > 0 && skuWrapUp?.[0]?.info_on_hover ? skuWrapUp[0].info_on_hover : '';
    const movieAddOnData = hoverInfoData !== '' && <ReactMarkdown source={hoverInfoData} escapeHtml={false} />;
    const cartIconLabel = useSelector(getFeatureFlag(['cart-icon-label']));
    const isAddOnWrapUpPriceRange = useSelector(getFeatureFlag(['is-add-on-wrap-up-price-range-rendered']));

    const renderInfoIcon = () => (
        <div className={classes.infoButton}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <g>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0001 4.19446C11.1886 4.19446 5.66675 9.71628 5.66675 16.5278C5.66675 23.3393 11.1886 28.8611 18.0001 28.8611C24.8116 28.8611 30.3334 23.3393 30.3334 16.5278C30.3334 9.71628 24.8116 4.19446 18.0001 4.19446ZM3.66675 16.5278C3.66675 8.61171 10.084 2.19446 18.0001 2.19446C25.9162 2.19446 32.3334 8.61171 32.3334 16.5278C32.3334 24.4439 25.9162 30.8611 18.0001 30.8611C10.084 30.8611 3.66675 24.4439 3.66675 16.5278ZM17.0001 11.1945C17.0001 10.6422 17.4478 10.1945 18.0001 10.1945H18.0134C18.5657 10.1945 19.0134 10.6422 19.0134 11.1945C19.0134 11.7467 18.5657 12.1945 18.0134 12.1945H18.0001C17.4478 12.1945 17.0001 11.7467 17.0001 11.1945ZM18.0001 15.5278C18.5523 15.5278 19.0001 15.9755 19.0001 16.5278V21.8611C19.0001 22.4134 18.5523 22.8611 18.0001 22.8611C17.4478 22.8611 17.0001 22.4134 17.0001 21.8611V16.5278C17.0001 15.9755 17.4478 15.5278 18.0001 15.5278Z" fill="#6E3290" />
                    <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" d="M5.66675 16.5278C5.66675 9.71628 11.1886 4.19446 18.0001 4.19446C24.8116 4.19446 30.3334 9.71628 30.3334 16.5278C30.3334 23.3393 24.8116 28.8611 18.0001 28.8611C11.1886 28.8611 5.66675 23.3393 5.66675 16.5278ZM17.0001 11.1945C17.0001 10.6422 17.4478 10.1945 18.0001 10.1945H18.0134C18.5657 10.1945 19.0134 10.6422 19.0134 11.1945C19.0134 11.7467 18.5657 12.1945 18.0134 12.1945H18.0001C17.4478 12.1945 17.0001 11.7467 17.0001 11.1945ZM18.0001 15.5278C18.5523 15.5278 19.0001 15.9755 19.0001 16.5278V21.8611C19.0001 22.4134 18.5523 22.8611 18.0001 22.8611C17.4478 22.8611 17.0001 22.4134 17.0001 21.8611V16.5278C17.0001 15.9755 17.4478 15.5278 18.0001 15.5278Z" fill="white" />
                </g>
            </svg>
        </div>
    );
    const trashIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
            <path d="M1 4.04706H13M5.80176 7.34882V10.651M8.19824 7.34882V10.651M2.19824 4.04706H11.7982L10.8502 13.4384C10.8177 13.7616 10.6781 14.0602 10.458 14.2771C10.2379 14.494 9.95286 14.614 9.65744 14.6139H4.33904C4.04362 14.614 3.75858 14.494 3.53849 14.2771C3.3184 14.0602 3.17874 13.7616 3.14624 13.4384L2.19824 4.04706ZM4.20641 2.16297C4.30346 1.93642 4.45704 1.74492 4.64922 1.61079C4.84139 1.47667 5.06426 1.40545 5.29181 1.40546H8.70701C8.93466 1.40533 9.15766 1.47648 9.34995 1.61061C9.54225 1.74475 9.69591 1.93632 9.79301 2.16297L10.5994 4.04718H3.39941L4.20641 2.16297Z" stroke="#52297E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
    const removeButton = () => (
        isSlider
            ? (
                <Button
                    id={`btn-${sku?.id}`}
                    variant="contained"
                    className={`${classes.ctaButton} ${classes.ctaAddedButton}`}
                    onClick={() => selectItems(sku)}
                >
                    <b>Added</b> {trashIcon()}
                </Button>
            )
            : (
                <Button
                    id={`btn-${sku?.id}`}
                    variant="contained"
                    className={classes.editButton}
                    onClick={() => handleOpenModal('wrapup', wrapUpData, sku?.id, sku?.name, 'Edit')}
                >
                    <CheckBoxIcon className={classes.iconCheck} />Edit
                </Button>
            )
    );
    const addToCartButton = () => (
        isSlider
            ? (
                <Button
                    id={`btn-${sku?.id}`}
                    variant="contained"
                    className={classes.ctaButton}
                    onClick={() => selectItems(sku)}
                >
                    <b>Add To {cartIconLabel?.label || 'Cart'}</b>
                </Button>
            ) : (
                <Button
                    id={`btn-${sku?.id}`}
                    variant="contained"
                    className={classes.ctaButton}
                    onClick={() => handleOpenModal('wrapup', wrapUpData, sku?.id, sku?.name, 'Selected')}
                >
                    <b>Select</b>
                </Button>
            )
    );

    const transformedPrices = sku?.prices.reduce((acc, price) => {
        acc[price.type] = acc[price.type] || [];
        acc[price.type].push({
            type: price.type,
            value: price.value,
        });
        return acc;
    }, {});
    return (
        <div className={`${classes.addonGroup} ${isSlider ? classes.sliderGroup : ''}`}>
            <div className={classes.imgContent} role="presentation"  onClick={() => handlePopup()}>
                <img
                    className={classes.img}
                    src={`${sku?.image?.path}${sku?.image?.name}z.jpg`}
                    alt={sku?.image?.name}
                />
                {hoverInfoData !== '' && isSlider && !wrapupAddonRedesign && renderInfoIcon()}
            </div>
            <div className={classes.popUp}>
                <div className={classes.icon}>
                    {hoverInfoData !== '' && !isSlider  && (
                        <button type="button" onClick={handleClick} className={classes.infoButton} data-testid="info-button">
                            <InfoOutlinedIcon className={classes.infoButtonSvg} />
                        </button>
                    )}
                    <Popover
                        open={info}
                        anchorEl={info}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <div className={classes.iconContent}>
                            {movieAddOnData}
                        </div>
                    </Popover>
                </div>
            </div>

            <div role="presentation" onClick={() => handlePopup()}  className={movieSku ? classes.movieTitle : classes.title}>{sku?.name}</div>
            { movieSku && (<span role="presentation" onClick={handleSeetitleModal} className={classes.seeTitle}> See titles</span>)}
            {isSlider && (
                <div className={classes.priceContainer}>
                    <PriceRange
                        skuPriceRange={transformedPrices}
                        isMobile={false}
                        isAddOnWrapUpEnabled
                        priceRangeLayout={isAddOnWrapUpPriceRange ? [
                            {
                                title: 'Mobile',
                                viewport: 'Mobile',
                                price_layout: 'starting $xxx.xx',
                                sale_text: '',
                            },
                            {
                                title: 'Desktop',
                                viewport: 'Desktop',
                                price_layout: 'starting $xxx.xx',
                                sale_text: '',
                            },
                        ] : ''}
                    />
                </div>
            )}
            {selectedGroupId ?  removeButton() : addToCartButton() }
            {!isSlider
                ? (<>{movieSku ? <p className={classes.wraupCopy}>Emailed separately, free of charge. Choose a delivery date in checkout.</p> : <p className={classes.wraupCopy}>Shipped separately, free of charge. Choose a delivery date in checkout.</p>}</>) : ''}
            {addOnData[0]?.map((wrapupItem) => (
                wrapupItem?.sku === skuPartNumber  && <WrapUpModal key={seed(wrapupItem)} modalData={wrapupItem} closeModal={handleSeetitleModal} openModal={openSeetitleModal} />
            ))}
            {open && isSlider && (
                <AddonInfoModal
                    open={open}
                    setOpen={setOpen}
                    imageData={sku}
                    heading={sku?.name}
                    description={hoverInfoData}
                    LinkOrReference=""
                />
            )}
        </div>
    );
};

WrapUpUI.propTypes = {
    classes: object.isRequired,
    addOnData: arrayOf(arrayOf(shape({
        sku: string.isRequired,
        info_on_hover: string.isRequired,
    }))).isRequired,
    wrapUpData: shape({
        skuPartNumber: string.isRequired,
        sku: shape({
            name: string.isRequired,
            image: shape({
                name: string.isRequired,
                path: string.isRequired,
            }).isRequired,
            prices: array.isRequired,
            id: string.isRequired,
        }),
    }).isRequired,
    selectedGroupId: string,
    handleOpenModal: func.isRequired,
    wrapUpInfo: arrayOf(shape({
        sku: string.isRequired,
        info_on_hover: string.isRequired,
    })).isRequired,
    isSlider: bool,
    selectItems: func.isRequired,
    wrapupAddonRedesign: bool,
};
WrapUpUI.defaultProps = {
    selectedGroupId: null,
    isSlider: false,
    wrapupAddonRedesign: false,
};

export default withStyles(styles)(WrapUpUI);
